import axiosInstance from "../utils/axiosConfig";

const postFolgasObs = async (dadosFolgas) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest2/";
  const apiUrl = `${baseUrl}INT_APPMOTORISTA_GRAVACP`;

  // Garantir que sempre seja enviado um array
  const dadosParaEnviar = Array.isArray(dadosFolgas) ? dadosFolgas : [dadosFolgas];

  try {
    const response = await axiosInstance.post(apiUrl, dadosParaEnviar, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000, // Aumentar timeout para 10 segundos
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer a requisição:", error);

    throw new Error("Houve um problema ao enviar as folgas e observações.");
  }
};

export { postFolgasObs };
